import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapCheckboxRadioButtons as CheckboxRadioButtons } from '../../../neuro-ui';
import { QuestionTypeViewPropTypes } from '../../utils';
import {useQuestionContext} from '../QuestionContext';

const CheckboxRadioButton = (props) => {
  const {
    className,
    valueChanged,
    question,
    value: { value = [] } = {},
    type,
  } = props;

  const { appkey } = question;
  const { getQuestionAnswersArray } = useQuestionContext();

  return (
    <div className={className} id={appkey}>
      <CheckboxRadioButtons
        name={appkey}
        onChange={valueChanged}
        type={type}
        checkedValues={value}
        answerOptions={getQuestionAnswersArray({question})}
      />
    </div>
  );
};

CheckboxRadioButton.propTypes = {
  ...QuestionTypeViewPropTypes,
  type: PropTypes.oneOf(['radio', 'checkbox']),
};

export default CheckboxRadioButton;
